<template>
  <section class="justify-content-center mb-4">
    <table style="width: 100%" class="mb-3">
      <thead>
        <tr>
          <th  class="px-2">
            <input
              type="text"
              style="
                font-size: 11px;
                border: 1px solid #3a9af3;
                border-radius: 5px;
                color: #3a9af3;
                width: 100%;
              "
              :placeholder="__('traductionview.searchpointcontactname')"
              v-model="filtername"
              @change="onFilterNameChange()"
            />
          </th>
          <th  class="px-2">
            <input
              type="text"
              style="
                font-size: 11px;
                border: 1px solid #3a9af3;
                border-radius: 5px;
                color: #3a9af3;
                width: 100%;
              "
              :placeholder="__('traductionview.searchpointcontactlastname')"
              v-model="filterlastname"
              @change="onFilterLastNameChange()"
            />
          </th>
          <th  class="px-2">
            <input
              type="text"
              style="
                font-size: 11px;
                border: 1px solid #3a9af3;
                border-radius: 5px;
                color: #3a9af3;
                width: 100%;
              "
              :placeholder="__('traductionview.searchpointcontactemail')"
              v-model="filteremail"
              @change="onFilterEmailChange()"
            />
          </th>
          <th  class="px-2">
            <input
              type="text"
              style="
                font-size: 11px;
                border: 1px solid #3a9af3;
                border-radius: 5px;
                color: #3a9af3;
                width: 100%;
              "
              :placeholder="__('traductionview.searchcompany')"
              v-model="filtercompany"
              @change="onFilterCompanyChange()"
            />
          </th>
          <th class="text-right">
            <label for="checkbox" class="fts-12 font-weight-bold">{{
              __("traductionview.afficher")
            }}</label>
            <input
              type="checkbox"
              style="font-size: 11px; vertical-align: middle"
              id="checkbox"
              v-model="filterstatus"
              @change="onFilterStatusChange()"
            />
          </th>
          <th class="text-right">
            <label for="checkbox" class="fts-12 font-weight-bold">{{
              __("traductionview.showonlyPOC")
            }}</label>
            <input
              type="checkbox"
              style="font-size: 11px; vertical-align: middle"
              id="checkbox"
              v-model="filterpoc"
              @change="onFilterPocChange()"
            />
          </th>
        </tr>
      </thead>
    </table>
    <div class="col-md-12 mx-auto dashboardstyle pt-0">
      <table class="mx-auto text-center abc-table" style="width: 100%">
        <thead class="abc-title-table">
          <tr class="py-3" style="border-bottom: solid 1px #3a9af3">
            <th style="vertical-align: middle; width: 9%">
              {{ __("traductionview.nomnom") }}
              <button
                style="text-align: center"
                type="button"
                class="btn-sort"
                aria-label="Tri ascendant"
                v-on:click="projectSortAsc"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="9"
                  height="9"
                  fill="rgb(107, 107, 107)"
                  class="bi bi-caret-up-fill"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"
                  />
                </svg>
              </button>
              <button
                style="text-align: center"
                type="button"
                class="btn-sort"
                aria-label="Tri descendant"
                v-on:click="projectSortDsc"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="9"
                  height="9"
                  fill="rgb(107, 107, 107)"
                  class="bi bi-caret-down-fill"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"
                  />
                </svg>
              </button>
            </th>
            <th style="vertical-align: middle; width: 9%">
              {{ __("traductionview.usertype") }}
            </th>
            <th style="vertical-align: middle; width: 9%">
              {{ __("traductionview.email") }}
            </th>
            <th style="vertical-align: middle; width: 9%">
              {{ __("traductionview.titre") }}
              <button
                style="text-align: center"
                type="button"
                class="btn-sort"
                aria-label="Tri ascendant"
                v-on:click="titleSortAsc"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="9"
                  height="9"
                  fill="rgb(107, 107, 107)"
                  class="bi bi-caret-up-fill"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"
                  />
                </svg>
              </button>
              <button
                style="text-align: center"
                type="button"
                class="btn-sort"
                aria-label="Tri descendant"
                v-on:click="titleSortDsc"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="9"
                  height="9"
                  fill="rgb(107, 107, 107)"
                  class="bi bi-caret-down-fill"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"
                  />
                </svg>
              </button>
            </th>
            <th style="vertical-align: middle; width: 9%">
              {{ __("traductionview.tel") }}
              <button
                style="text-align: center"
                type="button"
                class="btn-sort"
                aria-label="Tri ascendant"
                v-on:click="phoneSortAsc"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="9"
                  height="9"
                  fill="rgb(107, 107, 107)"
                  class="bi bi-caret-up-fill"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"
                  />
                </svg>
              </button>
              <button
                style="text-align: center"
                type="button"
                class="btn-sort"
                aria-label="Tri descendant"
                v-on:click="phoneSortDsc"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="9"
                  height="9"
                  fill="rgb(107, 107, 107)"
                  class="bi bi-caret-down-fill"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"
                  />
                </svg>
              </button>
            </th>
            <th style="vertical-align: middle; width: 9%">
              {{ __("traductionview.entrepri") }}
              <button
                style="text-align: center"
                type="button"
                class="btn-sort"
                aria-label="Tri ascendant"
                v-on:click="companySortAsc"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="9"
                  height="9"
                  fill="rgb(107, 107, 107)"
                  class="bi bi-caret-up-fill"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"
                  />
                </svg>
              </button>
              <button
                style="text-align: center"
                type="button"
                class="btn-sort"
                aria-label="Tri descendant"
                v-on:click="companySortDsc"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="9"
                  height="9"
                  fill="rgb(107, 107, 107)"
                  class="bi bi-caret-down-fill"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"
                  />
                </svg>
              </button>
            </th>
            <!-- <th style="vertical-align: middle; width: 5%">
              {{ __("traductionview.lead") }}
              <button
                style="text-align: center"
                type="button"
                class="btn-sort"
                aria-label="Tri ascendant"
                v-on:click="leadSortAsc"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="9"
                  height="9"
                  fill="rgb(107, 107, 107)"
                  class="bi bi-caret-up-fill"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"
                  />
                </svg>
              </button>
              <button
                style="text-align: center"
                type="button"
                class="btn-sort"
                aria-label="Tri descendant"
                v-on:click="leadSortDsc"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="9"
                  height="9"
                  fill="rgb(107, 107, 107)"
                  class="bi bi-caret-down-fill"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"
                  />
                </svg>
              </button>
            </th> -->
            <th style="vertical-align: middle; width: 9%">
              {{ __("traductionview.registredon") }}
              <button
                style="text-align: center"
                type="button"
                class="btn-sort"
                aria-label="Tri ascendant"
                v-on:click="createdSortAsc"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="9"
                  height="9"
                  fill="rgb(107, 107, 107)"
                  class="bi bi-caret-up-fill"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"
                  />
                </svg>
              </button>
              <button
                style="text-align: center"
                type="button"
                class="btn-sort"
                aria-label="Tri descendant"
                v-on:click="createdSortDsc"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="9"
                  height="9"
                  fill="rgb(107, 107, 107)"
                  class="bi bi-caret-down-fill"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"
                  />
                </svg>
              </button>
            </th>
            <th style="vertical-align: middle; width: 9%">
              {{ __("traductionview.accountmanager") }}
              <button
                style="text-align: center"
                type="button"
                class="btn-sort"
                aria-label="Tri ascendant"
                v-on:click="hearSortAsc"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="9"
                  height="9"
                  fill="rgb(107, 107, 107)"
                  class="bi bi-caret-up-fill"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"
                  />
                </svg>
              </button>
              <button
                style="text-align: center"
                type="button"
                class="btn-sort"
                aria-label="Tri descendant"
                v-on:click="hearSortDsc"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="9"
                  height="9"
                  fill="rgb(107, 107, 107)"
                  class="bi bi-caret-down-fill"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"
                  />
                </svg>
              </button>
            </th>
            <th style="vertical-align: middle; width: 9%">
              {{ __("traductionview.bizwizmember") }}
            </th>
            <th style="vertical-align: middle; width: 5%"></th>
            <th style="vertical-align: middle; width: 9%"></th>
          </tr>
        </thead>
        <tbody
          id="ongoingproject"
          style="
            font-size: 9px;
            overflow: auto;
            display: block;
            max-height: 600px;
          "
        >
          <tr
            v-for="(customer, index) in customs"
            :key="index"
            class="py-3"
            style="border-bottom: solid 1px rgb(206, 206, 206)"
          >
            <td
              style="
                vertical-align: middle;
                width: 9%;
                overflow-wrap: break-word;
              "
            >
              {{ customer.firstname }} {{ customer.lastname }}
            </td>
            <td style="vertical-align: middle; width: 9%">
              <div v-if="customer.pro == 1" class="px-2">POC</div>
              <div v-else-if="customer.admin == 1" class="px-2">ADMIN</div>
              <div v-else-if="customer.manager == 1" class="px-2">STAFF</div>
              <span v-else class="px-2"> BEN </span>
            </td>
            <td
              style="
                vertical-align: middle;
                width: 9%;
                overflow-wrap: break-word;
              "
            >
              {{ customer.email }}
            </td>
            <td
              style="
                vertical-align: middle;
                width: 9%;
                overflow-wrap: break-word;
              "
            >
              {{ customer.title }}
            </td>
            <td style="vertical-align: middle; width: 9%">
              {{ customer.phone }}
            </td>
            <td
              style="
                vertical-align: middle;
                width: 9%;
                overflow-wrap: break-word;
              "
            >
              {{ customer.company }}
            </td>
            <td style="vertical-align: middle; width: 9%">
              {{ customer.created_at.slice(0, 10) }}
            </td>
            <td style="vertical-align: middle; width: 9%">
              <p class="mb-0">{{ customer.staff_assigned_name }}</p>
            </td>
            <td style="vertical-align: middle; width: 9%; font-weight: bold">
              <div v-if="customer.bizwiz == 1">
                <a
                  :href="
                    '/app/home/manager/' +
                    customer.country_id +
                    '/bizwiz/delete/' +
                    customer.id
                  "
                  onclick="return confirm('Are you sure? This client is not a Bizwiz client anymore?')"
                  class="btn btn-abc"
                  style="padding: 10px"
                >
                  <p class="mb-0">Not Bizwiz anymore</p>
                </a>
              </div>
              <div v-else>
                <a
                  :href="
                    '/app/home/manager/' +
                    country.id +
                    '/bizwiz/add/' +
                    customer.id
                  "
                  onclick="return confirm('Are you sure? This client is now a Bizwiz client')"
                  class="btn btn-abc"
                  style="padding: 10px"
                >
                  <p class="mb-0">Is Bizwiz</p>
                </a>
              </div>
            </td>
            <td style="vertical-align: middle; font-weight: bold; width: 5%">
              <a
                v-if="customer.id !== user.id"
                :href="`/${customer.id}/impersonate`"
                class="btn btn-warning btn-sm triggerspinner"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-eye"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z"
                  />
                  <path
                    d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z"
                  />
                </svg>
              </a>
            </td>
            <td
              v-if="user.admin == 1"
              style="vertical-align: middle; font-weight: bold; width: 9%"
            >
              <div
                v-if="customer.no_projects"
                style="
                  display: flex;
                  align-items: center;
                  gap: 5px;
                  flex-direction: column;
                "
              >
                <div v-if="customer.live_client == 0">
                  <a
                    :href="'/app/home/manager/user/desactivate/' + customer.id"
                  >
                    Desactivate
                  </a>
                </div>
                <div v-else>
                  <a :href="'/app/home/manager/user/activate/' + customer.id">
                    Activate
                  </a>
                </div>
                <a
                  :href="'/delete_user/' + customer.id"
                  onclick="return confirm('Are you sure? All data regarding this user will be deleted ?')"
                  class=""
                  style="padding: 10px; color: red"
                >
                  <p class="mb-0">{{ __("traductionview.supprimer") }}</p>
                </a>
              </div>
              <div v-else>
                <p class="mb-0">{{ __("traductionview.nodelete") }}</p>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>

<script>
export default {
  props: ["contacts", "country", "user", "token", "route"],

  data() {
    return {
      customs: [],
      filtername: "",
      filterlastname: "",
      filteremail: "",
      filterproject: "",
      filtercompany: "",
      filterstatus: "",
      filterpoc: "",
    };
  },

  mounted() {
    this.contacts.forEach((customer) => {
      this.customs.push(customer);
    });
  },

  methods: {
    onFilterNameChange() {
      this.customs = [];
      this.contacts.forEach((customer) => {
        var search = customer.firstname.toLowerCase();
        if (search.includes(this.filtername.toLowerCase())) {
          this.customs.push(customer);
        }
      });
    },
    onFilterLastNameChange() {
      this.customs = [];
      this.contacts.forEach((customer) => {
        var search = customer.lastname.toLowerCase();
        if (search.includes(this.filterlastname.toLowerCase())) {
          this.customs.push(customer);
        }
      });
    },
    onFilterEmailChange() {
      this.customs = [];
      this.contacts.forEach((customer) => {
        var search = customer.email.toLowerCase();
        if (search.includes(this.filteremail.toLowerCase())) {
          this.customs.push(customer);
        }
      });
    },
    onFilterCompanyChange() {
      this.customs = [];
      this.contacts.forEach((customer) => {
        var search = customer.company.toLowerCase();
        if (search.includes(this.filtercompany.toLowerCase())) {
          this.customs.push(customer);
        }
      });
    },
    onFilterStatusChange() {
      this.customs = [];
      if (this.filterstatus) {
        this.contacts.forEach((customer) => {
          if (customer.is_lead == 1) {
            this.customs.push(customer);
          }
        });
      } else {
        this.contacts.forEach((customer) => {
          this.customs.push(customer);
        });
      }
    },
    onFilterPocChange() {
      this.customs = [];
      if (this.filterpoc) {
        this.contacts.forEach((customer) => {
          if (customer.pro == 1) {
            this.customs.push(customer);
          }
        });
      } else {
        this.contacts.forEach((customer) => {
          this.customs.push(customer);
        });
      }
    },
    projectSortAsc() {
      this.customs = this.customs.sort(function (a, b) {
        if (a.firstname < b.firstname) {
          return -1;
        } else if (a.firstname > b.firstname) {
          return 1;
        } else {
          return 0;
        }
      });
    },
    projectSortDsc() {
      this.customs = this.customs.sort(function (a, b) {
        if (a.firstname > b.firstname) {
          return -1;
        } else if (a.firstname < b.firstname) {
          return 1;
        } else {
          return 0;
        }
      });
    },
    companySortAsc() {
      this.customs = this.customs.sort(function (a, b) {
        if (a.company < b.company) {
          return -1;
        } else if (a.company > b.company) {
          return 1;
        } else {
          return 0;
        }
      });
    },
    companySortDsc() {
      this.customs = this.customs.sort(function (a, b) {
        if (a.company > b.company) {
          return -1;
        } else if (a.company < b.company) {
          return 1;
        } else {
          return 0;
        }
      });
    },
    titleSortAsc() {
      this.customs = this.customs.sort(function (a, b) {
        if (a.title < b.title) {
          return -1;
        } else if (a.title > b.title) {
          return 1;
        } else {
          return 0;
        }
      });
    },
    titleSortDsc() {
      this.customs = this.customs.sort(function (a, b) {
        if (a.title > b.title) {
          return -1;
        } else if (a.title < b.title) {
          return 1;
        } else {
          return 0;
        }
      });
    },
    createdSortAsc() {
      this.customs = this.customs.sort(function (a, b) {
        if (a.created_at < b.created_at) {
          return -1;
        } else if (a.created_at > b.created_at) {
          return 1;
        } else {
          return 0;
        }
      });
    },
    createdSortDsc() {
      this.customs = this.customs.sort(function (a, b) {
        if (a.created_at > b.created_at) {
          return -1;
        } else if (a.created_at < b.created_at) {
          return 1;
        } else {
          return 0;
        }
      });
    },
    leadSortAsc() {
      this.customs = this.customs.sort(function (a, b) {
        if (a.is_lead < b.is_lead) {
          return -1;
        } else if (a.is_lead > b.is_lead) {
          return 1;
        } else {
          return 0;
        }
      });
    },
    leadSortDsc() {
      this.customs = this.customs.sort(function (a, b) {
        if (a.is_lead > b.is_lead) {
          return -1;
        } else if (a.is_lead < b.is_lead) {
          return 1;
        } else {
          return 0;
        }
      });
    },
    phoneSortAsc() {
      this.customs = this.customs.sort(function (a, b) {
        if (a.phone < b.phone) {
          return -1;
        } else if (a.phone > b.phone) {
          return 1;
        } else {
          return 0;
        }
      });
    },
    phoneSortDsc() {
      this.customs = this.customs.sort(function (a, b) {
        if (a.phone > b.phone) {
          return -1;
        } else if (a.phone < b.phone) {
          return 1;
        } else {
          return 0;
        }
      });
    },
    hearSortAsc() {
      this.customs = this.customs.sort(function (a, b) {
        if (a.hear_about < b.hear_about) {
          return -1;
        } else if (a.hear_about > b.hear_about) {
          return 1;
        } else {
          return 0;
        }
      });
    },
    hearSortDsc() {
      this.customs = this.customs.sort(function (a, b) {
        if (a.hear_about > b.hear_about) {
          return -1;
        } else if (a.hear_about < b.hear_about) {
          return 1;
        } else {
          return 0;
        }
      });
    },
  },
};
</script>
